module.exports = __webpack_public_path__ + "static/media/dsr_cer3.72bacb5c.svg";